<template>
  <v-row>
    <v-col>
      <v-row dense>
        <v-col class="text-h5 gray--text"> História medicamentosa </v-col>
      </v-row>

      <v-row dense v-if="showForm">
        <v-col>
          <v-combobox
            v-model="medicine"
            outlined
            dense
            label="Medicamento"
            :items="orderedMedicines"
            item-text="name"
            :hide-details="medicineError === ''"
            :error-messages="medicineError"
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="medicationHistoryFrequency"
            outlined
            dense
            label="Periodicidade"
            :items="medicationHistoryFrequencies"
            item-text="name"
            hide-details
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row v-if="showForm">
        <v-col>
          <v-textarea
            v-model.trim="description"
            v-uppercase
            outlined
            dense
            hide-details
            label="Descrição"
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row dense v-if="showForm">
        <v-col>
          <v-btn dark color="light-blue" @click="saveMedicationHistory">
            Adicionar
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="lodash.isEmpty(medicationHistories)" justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Sem história medicamentosa
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
          v-for="medicationHistory in medicationHistories"
          :key="medicationHistory.id"
          cols="12"
        >
          <v-card>
            <v-container fluid>
              <v-row align="center">
                <v-col cols="3">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Medicamento </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col> {{ medicationHistory.medicine.name }} </v-col>
                  </v-row>
                </v-col>

                <v-col cols="3">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Periodicidade </v-col>
                  </v-row>

                  <v-row
                    dense
                    v-if="medicationHistory.medicationHistoryFrequency"
                  >
                    <v-col>
                      {{ medicationHistory.medicationHistoryFrequency.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="4">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Descrição </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col> {{ medicationHistory.description }} </v-col>
                  </v-row>
                </v-col>

                <v-spacer />

                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deleteMedicationHistory(medicationHistory.id)"
                        v-if="allowDelete"
                      >
                        <v-icon>eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Excluir </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import GET_MEDICINES from "@/graphql/medicines.gql";
import GET_MEDICATION_HISTORY_FREQUENCIES from "@/graphql/medication_history_frequencies.gql";
import GET_MEDICATION_HISTORIES from "@/graphql/medication_histories.gql";
import SAVE_MEDICATION_HISTORY from "@/graphql/save_medication_history.gql";
import DELETE_MEDICATION_HISTORY from "@/graphql/delete_medication_history.gql";

export default {
  name: "MedicationHistory",
  props: {
    attendance: Object,
    showForm: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      medicines: [],
      medicine: null,
      medicineError: "",
      medicationHistoryFrequencies: [],
      medicationHistoryFrequency: null,
      description: "",
      medicationHistories: [],
      frenquencyName: "",
    };
  },
  apollo: {
    medicines: {
      query: GET_MEDICINES,
      variables: {
        disabled: false,
      },
      update({ medicines }) {
        return medicines.collection;
      },
    },
    medicationHistoryFrequencies: {
      query: GET_MEDICATION_HISTORY_FREQUENCIES,
    },
    medicationHistories: {
      query: GET_MEDICATION_HISTORIES,
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      pollInterval: 20000,
    },
  },
  computed: {
    orderedMedicines() {
      return this.lodash.orderBy(
        this.medicines,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  methods: {
    validate() {
      this.medicineError = "Esse campo deve ser preenchido.";

      if (this.medicine?.id) {
        this.medicineError = "";
      }

      if (this.medicineError === "") {
        return true;
      }

      return false;
    },
    saveMedicationHistory() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: SAVE_MEDICATION_HISTORY,
        variables: {
          attendanceId: this.attendance.id,
          medicationHistoryFrequencyId: this.medicationHistoryFrequency?.id,
          medicineId: this.medicine.id,
          description: this.description,
        },
      }).then(() => {
        this.medicine = null;
        this.medicationHistoryFrequency = null;
        this.description = "";

        this.refreshMedicationHistories();
      });
    },
    refreshMedicationHistories() {
      return this.$apollo.queries.medicationHistories.refetch();
    },
    async deleteMedicationHistory(medicationHistoryId) {
      await this.apolloMutate({
        mutation: DELETE_MEDICATION_HISTORY,
        variables: {
          medicationHistoryId: medicationHistoryId,
        },
      });

      await this.refreshMedicationHistories();
    },
  },
};
</script>

<style lang="scss" scoped></style>
